import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="master-recording-notes"
// Handles inline editing of master recording notes in search results
export default class extends Controller {
  // Handle click on edit button
  editNotes(event) {
    event.preventDefault()

    const btn = event.currentTarget
    const masterRecordingId = btn.dataset.masterRecordingId
    const detailRow = document.getElementById(`master_recording_detail_${masterRecordingId}`)

    if (!detailRow) {
      console.error("Couldn't find detail row for master recording", masterRecordingId)
      return
    }

    const notesDiv = detailRow.querySelector('div.notes')
    if (!notesDiv) {
      console.error("Couldn't find notes div in detail row")
      return
    }

    this.loadNotesEditor(masterRecordingId, notesDiv)
  }

  async loadNotesEditor(masterRecordingId, notesDiv) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    try {
      const response = await fetch(`/admin/master_recordings/${masterRecordingId}/edit_notes`, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-cache',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'text/html',
          'Accept': 'text/html'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const html = await response.text()
      this.updateNotesDiv(notesDiv, html)
      this.setupNotesForm(notesDiv, masterRecordingId)

    } catch (error) {
      console.error("Error loading notes editor:", error)
      alert("There was an error which prevents the editor from loading.")
    }
  }

  updateNotesDiv(notesDiv, html) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    // Clean out old content
    while (notesDiv.firstChild) {
      notesDiv.removeChild(notesDiv.firstChild)
    }

    // Append new content
    notesDiv.append(...doc.body.childNodes)
  }

  setupNotesForm(notesDiv, masterRecordingId) {
    const form = notesDiv.querySelector('form')
    if (!form) return

    const submitBtn = form.querySelector('input[type=submit]')
    const cancelBtn = form.querySelector('button[data-cancel]')

    // Handle form submission
    form.addEventListener('submit', (ev) => {
      ev.preventDefault()
      ev.stopPropagation()
      this.saveNotes(form, notesDiv, masterRecordingId)
    })

    // Handle cancel
    if (cancelBtn) {
      cancelBtn.addEventListener('click', (ev) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (confirm(cancelBtn.dataset.confirm || "Are you sure you want to cancel?")) {
          this.showNotes(notesDiv, masterRecordingId)
        }
      })
    }
  }

  async saveNotes(form, notesDiv, masterRecordingId) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const formData = new FormData(form)

    try {
      const response = await fetch(`/admin/master_recordings/${masterRecordingId}/update_notes`, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-cache',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        body: formData
      })

      const html = await response.text()
      this.updateNotesDiv(notesDiv, html)

    } catch (error) {
      console.error("Error saving notes:", error)
      alert("There was an error which prevents your notes from being saved.")
    }
  }

  async showNotes(notesDiv, masterRecordingId) {
    try {
      const response = await fetch(`/admin/master_recordings/${masterRecordingId}/notes`)

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const html = await response.text()
      this.updateNotesDiv(notesDiv, html)

    } catch (error) {
      console.error("Error loading notes:", error)
      alert("Cannot load notes")
    }
  }
}
